exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item.disabled[data-v-258fda21]{cursor:not-allowed;-webkit-user-select:none;-moz-user-select:none;user-select:none;opacity:.65}.page-link.active[data-v-258fda21]{background-color:#673ab7;color:#fff;border-color:#ddd}", ""]);

// exports
